<template>
  <tbody>
  <tr v-for="index in rows">
    <td v-for="index in columns">
      <Skeleton class="skeleton"></Skeleton>
    </td>
  </tr>
  </tbody>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton';

export default {
  name: "StaticSelectionsSkeletonLoader",
  components: {Skeleton},
  props: {
    rows: {
      type: Number,
      required: true
    },
    columns: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>
.skeleton {
  margin: 0 !important;
  padding: 0 !important;
  border-color: rgb(217, 217, 217);
  border-radius: 4px;
  height: 30px;
}
</style>